module.exports = __webpack_public_path__ + "img/amazing_black_ink_detailed_sketch_style_cat.jpg";